'use client'

import React from 'react'
import OfferOutUrl from '@/components/shared/OfferOutUrl'
import { ArrowRight, Sparkles, Tag } from 'lucide-react'

interface Props {
    unique_id: string
    outUrl: string
    merchantHref: string
    domain: string
    isCoupon: boolean
    couponCode?: string | null
    label?: string
    className?: string
}

const OfferCTAButton = ({
    unique_id,
    outUrl,
    merchantHref,
    domain,
    isCoupon,
    couponCode,
    label = 'Get Deal',
    className = ''
}: Props) => {
    return (
        <OfferOutUrl
            unique_id={unique_id}
            outUrl={outUrl}
            merchantHref={merchantHref}
            domain={domain}
            customClass={`w-full block ${className}`}
        >
            <div className="w-full rounded-xl py-2.5 px-4 text-center flex items-center justify-center gap-2 bg-[#071822] hover:bg-[#00d69f] hover:text-[#071822] active:scale-[0.98] text-white shadow-xs hover:shadow-md transition-all duration-200 cursor-pointer group/btn">
                <span className="text-xs sm:text-sm font-black tracking-wide">{label}</span>
                <ArrowRight size={14} className="text-white/80 group-hover/btn:text-[#071822] transition-colors duration-200 group-hover/btn:translate-x-1" />
            </div>
        </OfferOutUrl>
    )
}

export default OfferCTAButton